import {useMediaQuery} from '@mui/material';

export const useResponsiveStyles = theme => {
  const xsBR = useMediaQuery(theme.breakpoints.up('xs'));
  const smBR = useMediaQuery(theme.breakpoints.up('sm'));
  const mdBR = useMediaQuery(theme.breakpoints.up('md'));
  const lgBR = useMediaQuery(theme.breakpoints.up('lg'));
  const xlBR = useMediaQuery(theme.breakpoints.up('xl'));

  return sxObject => {
    let output = undefined;

    if (sxObject.hasOwnProperty('xs') && xsBR) output = sxObject['xs'];
    if (sxObject.hasOwnProperty('sm') && smBR) output = sxObject['sm'];
    if (sxObject.hasOwnProperty('md') && mdBR) output = sxObject['md'];
    if (sxObject.hasOwnProperty('lg') && lgBR) output = sxObject['lg'];
    if (sxObject.hasOwnProperty('xl') && xlBR) output = sxObject['xl'];

    return output || sxObject;
  };
};
